import { render, staticRenderFns } from "./fundtable.vue?vue&type=template&id=164c36c2"
import script from "./fundtable.vue?vue&type=script&lang=js"
export * from "./fundtable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports